module.exports = __webpack_public_path__ + "static/media/9.3b1896fa.png";